module.exports = __webpack_public_path__ + "img/a03.dfab315b.jpg";